import {
  Sun,
  Cable,
  Lightbulb,
  Cog,
  MoveVertical,
  Paintbrush,
  Zap,
  Wind,
  Droplets,
  Compass,
  SlidersHorizontal,
  Hammer,
  Settings,
  Home,
  Caravan,
} from 'lucide-react';

// Shared option list used by both the Options & Specs section and the
// Build My Barge configurator modal. Extracting this here breaks the
// circular import between OptionsSpecs.jsx and BargeConfigurator.jsx.
export const OPTIONS = [
  { icon: Sun, label: 'Open-helm' },
  { icon: Home, label: 'Captain\u2019s Cabin' },
  { icon: Lightbulb, label: 'LED work-light & nav-light package' },
  { icon: Paintbrush, label: 'Custom paint & accent color (crane & hammer only)' },
  { icon: Cable, label: 'Upgraded winch & rigging package' },
  { icon: Cog, label: 'Hydraulic Crane' },
  { icon: MoveVertical, label: 'Spuds System w/ Winch' },
  { icon: Settings, label: 'Rigging & Outboard Motor Install' },
  { icon: Zap, label: 'Premium Whole-Boat Electrical' },
  { icon: Wind, label: 'Air Compressor (30 gal, 175 PSI)' },
  { icon: Droplets, label: 'Bilge Pump w/ Autostart' },
  { icon: Sun, label: 'Solar Panel' },
  { icon: Compass, label: 'Extra Gauges & Chartplotter' },
  { icon: SlidersHorizontal, label: 'Controllers & Switches' },
  { icon: Hammer, label: 'ABSOLUTE Pneumatic Hammer 700' },
  { icon: Caravan, label: 'Trailer' },
];
